











































import HeadingButtons from "@/components/HeadingButtons.vue";
import AlertsDeliveryConfigItem from "@/components/AlertsDeliveryConfigItem.vue";
import AlertsDeliveryConfigForm from "@/components/AlertsDeliveryConfigForm.vue";
import { DeliveryConfig } from "@/types/alert";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    HeadingButtons,
    AlertsDeliveryConfigItem,
    AlertsDeliveryConfigForm,
  },
})
export default class AlertsDeliveryConfig extends Vue {
  created() {
    this.$store.dispatch("alerts/fetchDeliveryConfigs");
  }

  @State(state => state.alerts.deliveryConfigs)
  deliveryConfigs!: DeliveryConfig[];
  @State(state => state.alerts.showAddDeliveryConfig)
  showAddDeliveryConfig!: boolean;

  get hasDeliveryConfigs() {
    return this.deliveryConfigs && this.deliveryConfigs.length > 0;
  }

  get previewDeliveryConfigs(): DeliveryConfig[] {
    return [
      {
        id: 0,
        delivery_type: "email",
        email: "jane@example.com",
        slack_url: "",
        slack_channel: "",
      },
      {
        id: 1,
        delivery_type: "slack",
        email: "",
        slack_url: "https://...",
        slack_channel: "#alerts",
      },
    ];
  }

  toggleAddDeliveryConfig() {
    const toggle = this.showAddDeliveryConfig ? "Hide" : "Show";
    this.$ga.toggle(`${toggle} add delivery config`);
    this.$store.dispatch("alerts/setShowAddDeliveryConfig", !this.showAddDeliveryConfig);
  }
}
